import React, { memo } from 'react'
import { ISelectOption, Select } from 'components/forms/Selects'
import SuggestLocation, { ILocationSuggestion } from 'transfix-ui/components/SuggestLocation'
import { RADIUS_OPTIONS } from 'apps/marketplace/utils/constants/radii'
import { LANE_RATE } from 'apps/marketplace/utils/constants/rates'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'
import { capitalize } from 'utils/capitalize'

interface ILocationPropType {
  city: string
  state: string
}

interface ILocationsProp {
  rateType: string
  pickupLocation: ILocationPropType
  pickupRadiusMiles: number | null
  deliveryLocation: ILocationPropType
  deliveryRadiusMiles: number | null
  onChange: (arg: Partial<ChangeRateData>) => void
  disabled: boolean
}

export const Locations = memo<ILocationsProp>(
  ({
    deliveryLocation,
    deliveryRadiusMiles,
    disabled,
    onChange,
    pickupLocation,
    pickupRadiusMiles,
    rateType,
  }) => {
    const handlePickupChange = (value: ILocationSuggestion) => {
      onChange({ pickupLocation: value })
    }
    const handleDeliveryChange = (value: ILocationSuggestion) => {
      onChange({ deliveryLocation: value })
    }
    const handleRadiusChange = ({ value }: ISelectOption, id: string) => {
      const [first, ...rest] = id.split('-')
      const key = `${first}${rest.map((entry: string | undefined) => capitalize(entry)).join('')}`
      onChange({ [key]: value })
    }

    return (
      <div className='row'>
        <div className='col-md-4 col-xs-8'>
          <SuggestLocation
            label='Pickup City'
            required
            dataTest='add-pickup'
            placeholder='Enter a City'
            value={pickupLocation}
            onChange={handlePickupChange}
            resultTypes={['City', 'PostalCode']}
            disabled={disabled}
          />
        </div>
        <div className='col-md-2 col-xs-4'>
          <Select
            id='pickup-radius-miles'
            label='Radius'
            options={RADIUS_OPTIONS}
            value={RADIUS_OPTIONS.find(entry => entry.value === pickupRadiusMiles)}
            onChange={handleRadiusChange}
            dataTest='pickup-radius-miles'
            disabled={disabled}
          />
        </div>
        {rateType === LANE_RATE && (
          <>
            <div className='col-md-4 col-xs-8'>
              <SuggestLocation
                label='Delivery City'
                required
                dataTest='add-destination'
                placeholder='Enter a City'
                value={deliveryLocation}
                onChange={handleDeliveryChange}
                resultTypes={['City', 'PostalCode']}
                disabled={disabled}
              />
            </div>
            <div className='col-md-2 col-xs-4'>
              <Select
                id='delivery-radius-miles'
                label='Radius'
                options={RADIUS_OPTIONS}
                value={RADIUS_OPTIONS.find(entry => entry.value === deliveryRadiusMiles)}
                onChange={handleRadiusChange}
                dataTest='delivery-radius-miles'
                disabled={disabled}
              />
            </div>
          </>
        )}
      </div>
    )
  }
)
